import { Box, Typography } from '@mui/material';
import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { getActionsColConfig } from 'src/components/DataTable';
import { useStoreUnitActions } from 'src/redux/helpers';
import {
  SolutionEdgeWorkloadItem,
  SolutionEdgeWorkloadItemField,
  SolutionEdgeWorkloadRepositoryType,
  SolutionEdgeWorkloadStatus as StatusType,
} from 'src/pages/Solutions/types';
import SolutionEdgeWorkloadActions from './components/SiteEdgeWorkloadActions';
import SolutionEdgeWorkloadRepositoryList from './components/SiteEdgeWorkloadRepositoryList';
import SolutionEdgeWorkloadStatus from './components/SiteEdgeWorkloadStatus';
import sitesStore, { useSiteEdgeWorkloadConfigList } from '../redux';

const columns = [
  {
    id: SolutionEdgeWorkloadItemField.Name,
    title: 'Name',
  },
  {
    id: SolutionEdgeWorkloadItemField.Description,
    title: 'Description',
  },
  {
    id: SolutionEdgeWorkloadItemField.RepositoryURL,
    title: 'Repository URL',
  },
  {
    id: SolutionEdgeWorkloadItemField.BranchName,
    title: 'Branch',
  },
  {
    id: SolutionEdgeWorkloadItemField.Path,
    title: 'Path',
  },
  {
    id: SolutionEdgeWorkloadItemField.DeploymentStatusData,
    title: 'Status',
    Component: SolutionEdgeWorkloadStatus,
  },

  getActionsColConfig(SolutionEdgeWorkloadActions),
];

function SiteConfigurations() {
  const { siteId } = useParams();
  const [data, loading] = useSiteEdgeWorkloadConfigList();
  const siteEdgeData: SolutionEdgeWorkloadItem[] = [];
  (Array.isArray(data) ? data : []).forEach((name) => {
    if (!name) return;
    const deploymentStatus = name.deploymentStatus ?? '';

    // Extract per-cluster deployment statuses from siteClusters
    const clusterStatuses: { clusterId: string; clusterName?: string; status: string; deploymentErrorMessage?: string }[] = [];
    try {
      if (name?.siteClusters && Array.isArray(name.siteClusters)) {
        name.siteClusters.forEach((site) => {
          if (site?.clusterDeploymentStatus && typeof site.clusterDeploymentStatus === 'object') {
            Object.entries(site.clusterDeploymentStatus).forEach(
              ([clusterId, value]) => {
                const entry = typeof value === 'object' && value !== null
                  ? value as { clusterName: string; status: string; deploymentErrorMessage?: string }
                  : { clusterName: '', status: String(value ?? ''), deploymentErrorMessage: '' };
                clusterStatuses.push({
                  clusterId,
                  clusterName: entry.clusterName || clusterId,
                  status: entry.status || '',
                  deploymentErrorMessage: entry.deploymentErrorMessage || '',
                });
              }
            );
          }
        });
      }
    } catch {
      // Gracefully handle malformed siteClusters data
    }

    const item: SolutionEdgeWorkloadItem = {
      ...name,
      deploymentStatusData: JSON.stringify({
        status:
          deploymentStatus === 'Deployment Paused'
            ? deploymentStatus.replace(
                'Deployment Paused',
                StatusType.paused
              )
            : deploymentStatus,
        errorMsg: name.deploymentMessage ?? '',
        clusterStatuses,
        deploymentSummary: name.deploymentSummary ?? '',
        activeDeploymentCount: name.activeDeploymentCount ?? 0,
        totalDeploymentCount: name.totalDeploymentCount ?? 0,
        deploymentPaused: name.deploymentPaused ?? false,
      }),
    };
    siteEdgeData.push(item);
  });
  const actions = useStoreUnitActions(sitesStore);

  useEffect(() => {
    actions.edgeWorkloadConfigurations(siteId);
  }, [siteId]);

  return (
    <>
      <Box display="flex" justifyContent="space-between" alignItems="center">
        <Typography
          style={{
            fontSize: '18px',
            marginTop: '10px',
            fontFamily: 'Stolzl',
            color: '#242424',
          }}
        >
          PEPsense Core and Common
        </Typography>
      </Box>
      <br />
      <SolutionEdgeWorkloadRepositoryList
        title="Git repository"
        data={siteEdgeData}
        columns={columns}
        repositoryType={SolutionEdgeWorkloadRepositoryType.PepsenseEdge}
        loading={loading}
      />
    </>
  );
}

export default SiteConfigurations;
